import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Stepper from 'bs-stepper';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Datepicker, InputDataForForm, Organization, Res } from 'src/app/models';
import { LanguageService, ApiOrganizationsService, DatetimeService, NotificationService } from 'src/app/services';

@Component({
  selector: 'app-organization-edit',
  templateUrl: './organization-edit.component.html',
  styleUrls: ['./organization-edit.component.css']
})
export class OrganizationEditComponent implements OnInit {

  stepper: Stepper;
  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  formData: Organization;
  formValid: boolean = true;
  orgId: string;
  inputDataForForm: InputDataForForm;
  tableData = [
    {id: 0, name: 'name'},
    {id: 1, name: 'department'},
    {id: 2, name: 'position'},
    {id: 3, name: 'role'},
    {id: 4, name: 'status'},
    {id: 5, name: 'action'},
  ]

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private apiOrganizations: ApiOrganizationsService,
    private router: Router,
    private datetimeService: DatetimeService,
    private currentRoute: ActivatedRoute,
    private notification: NotificationService,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.orgId = this.currentRoute.snapshot.paramMap.get('id');

    this.onEdit();
    this.initStepper();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  initStepper(): void {

    this.stepper = new Stepper(document.querySelector('#stepper1'), {
      linear: false,
      animation: true
    })
  }


  /**
   * 
   */
  nextStep(): void {

    this.stepper.next();
  }
  

  /**
   * 
   */
  prevStep(): void {

    this.stepper.previous();
  }


  /**
   * 
   * @param value any
   */
  setData(value: any): void {

    this.formData = value.form;
    this.formValid = value.valid
  }


  /**
   * 
   */
  onEdit(): void {

    if(!this.orgId) return;

    this.progressRef.start();

    this.subscriptions.add(
      this.apiOrganizations.edit(this.orgId).subscribe((response: Res) => { console.log('[RESPONSE] edit organization: ', response);
          
        if(response != null){
        
          this.inputDataForForm = {
            action: 'edit',
            value: response.result
          }
        }

        this.progressRef.complete();
      },
      error => {
        this.progressRef.complete();
      })
    );
  }


  /**
   * 
   */
  onUpdate(): void {

    let form: Organization = {...this.formData};

    this.formData.vat_payer.date ?  this.datetimeService.convertDateForDB(<Datepicker>this.formData.vat_payer.date) : this.formData.vat_payer.date;

    this.progressRef.start();

    this.subscriptions.add(
      this.apiOrganizations.update(form).subscribe((response: Res) => { console.log('[RESPONSE] createOrganizations: ', response);
          
        if(response != null){
        
          this.inputDataForForm = { action: 'update' }
          this.onEdit();
          this.notification.show('success', 'Данные успешно сохранены!');
        }

        this.progressRef.complete();
      },
      error => { 
        this.progressRef.complete();
      })
    );
  }

  backTo(id: string) {

    this.router.navigate(['organizations', 'profile', this.orgId]);

  }

}
